import axios from 'axios';
import { HUB_URL_ADMIN } from '../config';
import { restoreSettings } from './settings';

const source = axios.CancelToken.source();
const instance = axios.create({
  baseURL: HUB_URL_ADMIN,
  cancelToken: source.token,
});

instance.interceptors.request.use(config => {
  const settings = restoreSettings() || {};
  const runtimeBaseUrl =
    settings.hubUrlAdmin || settings.HUB_URL_ADMIN || HUB_URL_ADMIN || '';

  if (runtimeBaseUrl) {
    config.baseURL = runtimeBaseUrl;
  }

  return config;
});

export default instance;
